// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","nav":"App_nav__Yz+gE","link":"App_link__kpF6Q","title":"App_title__YS7Xx"};